/**
 * DOM Utilities - DOM manipulation utilities
 */

// Query selector
function safeQuery(selector, parent = document) {
  return parent.querySelector(selector);
}

// Query selector all
function safeQueryAll(selector, parent = document) {
  return parent.querySelectorAll(selector);
}

// Add event listener
function on(element, event, handler, options) {
  if (!element) return () => {};
  element.addEventListener(event, handler, options);
  return () => element.removeEventListener(event, handler, options);
}

// Remove event listener
function off(element, event, handler, options) {
  if (!element) return;
  element.removeEventListener(event, handler, options);
}

// Set attributes on an element
function setAttributes(element, attributes) {
  if (!element) return;
  
  Object.entries(attributes).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      element.removeAttribute(key);
    } else {
      element.setAttribute(key, value);
    }
  });
}

// Export the utility functions
window.DOMUtils = {
  query: safeQuery,
  queryAll: safeQueryAll,
  on,
  off,
  setAttributes
};
